import { useState } from "react";
import AgentResponseLayout from "../../../components/agent/AgentResponseLayout";
import SelectInput from "../../../components/forms/SelectInput";
import MultiSelectInput from "../../../components/forms/MultiSelectInput";
import NotesField from "../../../components/forms/NotesField";
import { useAgentResponse } from "../../../js/hooks/useAgentResponse";
import {
  DECK_OPTIONS,
  PATIO_OPTIONS,
  POOL_OPTIONS,
  PORCH_OPTIONS,
  ROOF_OPTIONS,
  SIDING_OPTIONS,
  SOLAR_OPTIONS,
  WINDOW_OPTIONS,
} from "../../../js/utils/agentResponseOptions";

const OUTDOOR_KITCHEN = [
  { value: "yes", label: "Outdoor kitchen present" },
  { value: "partial", label: "Grill station / partial" },
  { value: "none", label: "None" },
];

export default function AgentResponseExterior() {
  const { response, saveSection, goBack, goNext } = useAgentResponse("exterior");
  const saved = response?.exterior || {};
  const [form, setForm] = useState(null);
  const current = form || saved;

  function update(event) {
    const { name, value } = event.target;
    setForm((prev) => ({ ...(prev || saved), [name]: value }));
  }

  async function handleContinue() {
    await saveSection(current);
    goNext();
  }

  if (!response) {
    return (
      <AgentResponseLayout title="Exterior" onBack={goBack} onContinue={() => {}}>
        <p>Loading response…</p>
      </AgentResponseLayout>
    );
  }

  return (
    <AgentResponseLayout
      response={response}
      sectionKey="exterior"
      title="Exterior"
      lead="Capture outdoor living and the building envelope so you can match porch, roof, siding, and windows to the buyer’s exterior page."
      onBack={goBack}
      onContinue={handleContinue}
    >
      <section className="checklist-section">
        <h2>Outdoor Living</h2>
        <MultiSelectInput label="Porch" name="porch" values={current.porch || []} onChange={update} options={PORCH_OPTIONS} />
        <SelectInput label="Deck" name="deck" value={current.deck} onChange={update} options={DECK_OPTIONS} />
        <SelectInput label="Patio" name="patio" value={current.patio} onChange={update} options={PATIO_OPTIONS} />
        <SelectInput
          label="Outdoor kitchen"
          name="outdoorKitchen"
          value={current.outdoorKitchen}
          onChange={update}
          options={OUTDOOR_KITCHEN}
        />
        <MultiSelectInput label="Pool / spa" name="poolSpa" values={current.poolSpa || []} onChange={update} options={POOL_OPTIONS} />
      </section>
      <section className="checklist-section">
        <h2>Building Envelope</h2>
        <MultiSelectInput label="Roof" name="roof" values={current.roof || []} onChange={update} options={ROOF_OPTIONS} />
        <MultiSelectInput label="Siding" name="siding" values={current.siding || []} onChange={update} options={SIDING_OPTIONS} />
        <MultiSelectInput label="Windows" name="windows" values={current.windows || []} onChange={update} options={WINDOW_OPTIONS} />
        <SelectInput label="Solar" name="solar" value={current.solar} onChange={update} options={SOLAR_OPTIONS} />
        <NotesField
          label="Exterior notes"
          name="notes"
          value={current.notes}
          onChange={update}
          placeholder="Curb appeal, roof age if known, outdoor living quality, or HOA exterior rules."
        />
      </section>
    </AgentResponseLayout>
  );
}
